// AdSense — utilitaires côté client
// La config (activation + slots) est récupérée depuis l'API et mise en cache.
// L'admin la modifie depuis /admin → onglet "AdSense".

import { api } from "./api";

export const ADSENSE_CLIENT = "ca-pub-7493177636919221";

let _config = { enabled: false, slots: { homeBanner: "", inFeed: "", sidebar: "", trackBottom: "", articleInline: "" } };
let _ready = null;
let _listeners = new Set();

const emitChange = () => _listeners.forEach((cb) => { try { cb(_config); } catch {} });

/** S'abonner aux changements de config (re-render automatique). */
export const onAdsenseConfigChange = (cb) => {
  _listeners.add(cb);
  return () => _listeners.delete(cb);
};

/** Charge la config depuis l'API (1 seule fois par session, cache mémoire). */
export const loadAdsenseConfig = () => {
  if (_ready) return _ready;
  _ready = api.get("/adsense/config")
    .then(({ data }) => {
      _config = {
        enabled: !!data.enabled,
        slots: { ...(_config.slots || {}), ...(data.slots || {}) },
      };
      emitChange();
      return _config;
    })
    .catch(() => _config);
  return _ready;
};

/** Force un reload (utilisé par l'admin après save). */
export const reloadAdsenseConfig = () => {
  _ready = null;
  return loadAdsenseConfig();
};

export const getAdsenseConfig = () => _config;
export const isAdsenseEnabled = () => !!_config.enabled;
export const getSlotId = (key) => (_config.slots || {})[key] || "";

/**
 * Pousse un slot dans la file AdSense.
 * Robuste aux double-mount (StrictMode) et aux ad-blockers.
 */
export const pushSlot = (el) => {
  if (!el || el.dataset.adsLoaded === "1") return;
  if (typeof window === "undefined") return;
  try {
    (window.adsbygoogle = window.adsbygoogle || []).push({});
    el.dataset.adsLoaded = "1";
  } catch { /* ad-blocker / script bloqué : silent */ }
};
